import useResize from '@/hooks/useResize';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import {
    ContentTitle,
    ContentSection,
    SectionContent,
    ImagePlaceholder,
    CardGrid,
    CardIcon,
    CardTitle,
    CardDescription,
    ContentSubtitle,
    RadioTable,
} from '../style';
import { Box, Card, Flex } from '@/layout';
import { Text } from '@/components/UI/Typography/Text';
import { FormControlLabel, Radio } from '@mui/material';

const ChinaCompanyCheckList = () => {

    //   @ts-ignore
    const { t } = useTranslation();
    const { isTablet, isMobile } = useResize();

    // 获取服务区块标题
    const servicesCheck = t('pages.index.GoGlobal.chinaCompanyCheckList.servicesCheck', { returnObjects: true }) as {
        section1: string;
        section2: string;
        section3: string;
        section4: string;
        section5: string;
    };

    // 获取所有选项
    const options = t('pages.index.GoGlobal.chinaCompanyCheckList.options', { returnObjects: true }) as Array<{
        question: string;
        value: string;
    }>;

    // 定义每个区块包含的问题数量（按照设计稿：法律4个、会计4个、财务3个、检测3个、市场3个）
    const sectionsConfig = [
        { key: 'section1', count: 4 },
        { key: 'section2', count: 4 },
        { key: 'section3', count: 3 },
        { key: 'section4', count: 3 },
        { key: 'section5', count: 3 },
    ];

    // 将选项按区块分组，并为每个问题添加连续编号
    const groupedOptions: Array<{
        title: string;
        questions: Array<{ question: string; value: string; index: number }>;
    }> = [];

    let currentIndex = 0;
    sectionsConfig.forEach(section => {
        const questions = options.slice(currentIndex, currentIndex + section.count).map((opt, idx) => ({
            ...opt,
            index: currentIndex + idx + 1, // 1-based index，持续累加
        }));
        groupedOptions.push({
            title: servicesCheck[section.key as keyof typeof servicesCheck],
            questions,
        });
        currentIndex += section.count;
    });

    // 根據options的內容建立物件進行Radio綁定，使用useState管理狀態
    const initialState = options.reduce((acc, option, idx) => {
        acc[`question-${idx + 1}`] = ''; // 初始化为未选择状态
        return acc;
    }, {} as { [key: string]: string });

    const [optionsState, setOptionsState] = useState(initialState);

    return (
        <>
            <Box marginBottom={'20px'}>
                <ContentTitle isMobile={isMobile} textAlign="center">{t('pages.index.GoGlobal.chinaCompanyCheckList.title')}</ContentTitle>
                <ContentSubtitle>{t('pages.index.GoGlobal.chinaCompanyCheckList.subtitle')}</ContentSubtitle>
            </Box>

            <ContentSection isMobile={isMobile}>
                <SectionContent isMobile={isMobile}>
                    {t('pages.index.GoGlobal.chinaCompanyCheckList.intro').split('\n').map((line, i) => (
                        <span key={i}>{line}<br /></span>
                    ))}
                </SectionContent>
            </ContentSection>

            {/* 循环渲染所有区块 */}
            {groupedOptions.map((section, sectionIdx) => (
                <ContentSection key={sectionIdx} isMobile={isMobile}>
                    <Flex width={'100%'} gridGap={'20px'} flexDirection={isMobile ? 'column' : 'row'} justifyContent={'center'} alignContent={'center'}>
                        <Flex width={'100%'} justifyContent={'center'} alignContent={'center'} flexDirection={'column'}>
                            <Box marginBottom={'20px'}>
                                <ContentTitle isMobile={isMobile}>{section.title}</ContentTitle>
                            </Box>
                            <RadioTable>
                                {section.questions.map((question) => (
                                    <li key={question.index}>
                                        <Text>
                                            {question.index}.
                                        </Text>
                                        <Text style={{ maxWidth: '750px' }}>
                                            {question.question.split(':').map((part, i) => (
                                                <span key={i}>
                                                    {i == 0 && (
                                                        <Text fontWeight={'bold'}>{part}:</Text>
                                                    )}
                                                    {i > 0 && (
                                                        <Text>{part}</Text>
                                                    )}
                                                </span>
                                            ))}
                                        </Text>
                                        <Box width="120px" flexShrink={0} marginLeft={'auto'}>
                                            <Flex alignItems={'center'}>
                                                <FormControlLabel
                                                    control={<Radio color="success" checked={optionsState[`question-${question.index}`] === 'yes'} onChange={() => {
                                                        setOptionsState(prev => ({
                                                            ...prev,
                                                            [`question-${question.index}`]: 'yes'
                                                        }));
                                                    }} name={`question-${question.index}`} />}
                                                    label={t('pages.index.GoGlobal.chinaCompanyCheckList.value.yes')}
                                                    labelPlacement="end"
                                                />
                                                <FormControlLabel
                                                    control={<Radio color="success" checked={optionsState[`question-${question.index}`] === 'no'} onChange={() => {
                                                        setOptionsState(prev => ({
                                                            ...prev,
                                                            [`question-${question.index}`]: 'no'
                                                        }));
                                                    }} name={`question-${question.index}`} />}
                                                    label={t('pages.index.GoGlobal.chinaCompanyCheckList.value.no')}
                                                    labelPlacement="end"
                                                />
                                            </Flex>
                                        </Box>
                                    </li>
                                ))}
                            </RadioTable>
                        </Flex>
                    </Flex>
                </ContentSection>
            ))}
        </>
    );
};

export default ChinaCompanyCheckList;
